<template>
  <div class="AppTopNav">
    <div class="header">
      <div class="leftPart">{{ tenantName }}教务管理系统</div>
      <div class="rightPart">
        <!--        <div>-->
        <!--          <img class="messagePic" src="../../assets/png/message.png" alt=""/>-->
        <!--        </div>-->
        <div>
          <img class="headPic" :src="userInfo.avatar" alt=""/>
          <span class="userName">{{ userInfo.nickname }}</span>
        </div>
        <div>
          <el-dropdown :hide-on-click="false" trigger="click" @command="handleClick">
            <el-badge :value="messageList.total?messageList.total:null" class="item">
              <i class="el-icon-bell icon"></i>
            </el-badge>
            <el-dropdown-menu v-if="msgList.length" style="max-width: 300px">
              <div class="infinite-list" v-infinite-scroll="loadMessage"
                   style="max-height: 500px;">
                <el-dropdown-item v-for="item in msgList">{{ dataFormat(item.time) }} {{ item.nickname }}
                  {{ item.content }}
                </el-dropdown-item>
              </div>
              <el-link style="color: #10689c;right: 10px;float: right;position: relative"
                       @click="handleMessageReceive"
              >全部已读
              </el-link>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div>
          <el-dropdown :hide-on-click="false" @command="handleClick">
            <i class="el-dropdown-link el-icon-setting icon"/>
            <el-dropdown-menu>
              <el-dropdown-item command="1">切换机构</el-dropdown-item>
              <el-dropdown-item command="5">机构配置</el-dropdown-item>
              <el-dropdown-item command="2">账号设置</el-dropdown-item>
              <!--              <el-dropdown-item command="3">帮助中心</el-dropdown-item>-->
              <el-dropdown-item command="4">退出账号</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <AccountSettingModal></AccountSettingModal>
    <TenantSettingModal></TenantSettingModal>
    <institutionModal :isView="isView"></institutionModal>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import AccountSettingModal from "@/pages/AppTopNavPage/AccountSettingModal";
import TenantSettingModal from "@/pages/AppTopNavPage/TenantSettingModal";
import InstitutionModal from "@/pages/Login/institutionModal";
import {formatDate} from "element-ui/src/utils/date-util";

export default {
  name: "AppTopNav",
  components: {InstitutionModal, AccountSettingModal, TenantSettingModal},
  data() {
    return {
      visible: false,
      isView: false,
      msgList: [],
    };
  },
  computed: {
    ...mapState("user", ["userInfo", "permissionCode", "messageList"]),
    ...mapState("tenant", ["tenantsList", "tenantName"]),
  },
  watch: {
    messageList: {
      handler(newVal, oldVal) {
        if (!this.msgList.length) {
          this.msgList = [...newVal.data]
        }
      }
    }
  },
  async mounted() {
    let res = await this.getSystemMessage({size: 20});
    this.msgList = [...res.data.data];
  },
  methods: {
    ...mapActions("user", ["loginOut", "getSystemMessage", "addMessageReceive"]),
    ...mapMutations("user", ["setData"]),
    ...mapMutations("tenant", ["setTenantData"]),
    ...mapActions("tenant", ["getUserTenants"]),
    async handleMessageReceive() {
      let list = this.msgList.map(item => item.id);
      await this.addMessageReceive(list);
      this.msgList = [];
      this.setData({key: "messageList", value: {}})
    },
    async loadMessage() {
      if (this.messageList.page && this.messageList.size * this.messageList.page >= this.messageList.total) return;
      let res = await this.getSystemMessage({page: this.messageList.page + 1});
      this.msgList = this.msgList.concat(...res.data.data)
    },
    dataFormat(time) {
      return formatDate(time, "yyyy-MM-dd HH:mm")
    },
    async handleClick(val) {
      if (val === "1") {
        await this.getUserTenants();
        this.setData({key: "institutionModalVisible", value: true});
      }
      if (val === "5") {
        this.setTenantData({key: "tenantSettingModalVisible", value: true});
      }
      if (val === "2") {
        this.setData({key: "accountSettingModalVisible", value: true});
      }
      if (val === "4") {
        this.$confirm("是否退出登录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
            .then(async () => {
              await this.loginOut();
              await this.$router.push({name: "Login"});
              localStorage.removeItem("userId");
              // window.location.reload();
              this.$message({
                type: "success",
                message: "退出成功!",
              });
            })
            .catch(() => {
            });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.AppTopNav {
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .leftPart {
    }

    .rightPart {
      width: 250px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .headPic {
        width: 25px;
        height: 25px;
        border-radius: 50%;
        line-height: 30px;
        vertical-align: middle;
        margin: 0 10px;
      }

      .userName {
        font-size: 13px;
      }

      .icon {
        color: white;
        font-size: 20px;
      }
    }
  }
}

.infinite-list {
  overflow-y: scroll;

  ::v-deep::-webkit-scrollbar {
    display: none;
  }

  .el-dropdown-menu__item {
    line-height: unset;
    padding: 5px 10px;
  }
}
</style>
<style>
.AppTopNav {
  .header {
    .el-badge__content {
      margin-top: 20px
    }
  }
}

</style>
